var map = {
	"./skins/IBC-dyst-2025": [
		130,
		15
	],
	"./skins/IBC-dyst-2025.css": [
		402,
		33
	],
	"./skins/IBC-dyst-2025.js": [
		130,
		15
	],
	"./skins/aktionaerliga-2024": [
		131,
		14
	],
	"./skins/aktionaerliga-2024.css": [
		403,
		32
	],
	"./skins/aktionaerliga-2024.js": [
		131,
		14
	],
	"./skins/aktionaerliga-2025": [
		132,
		13
	],
	"./skins/aktionaerliga-2025.css": [
		404,
		31
	],
	"./skins/aktionaerliga-2025.js": [
		132,
		13
	],
	"./skins/bibliotekarernes-sep-2024": [
		133,
		12
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		405,
		30
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		133,
		12
	],
	"./skins/boersen-spiel-sep-2024": [
		134,
		11
	],
	"./skins/boersen-spiel-sep-2024.css": [
		406,
		29
	],
	"./skins/boersen-spiel-sep-2024.js": [
		134,
		11
	],
	"./skins/borsgruppenliu-jan-2024": [
		135,
		10
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		407,
		28
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		135,
		10
	],
	"./skins/fynske-bank-sep-2024": [
		136,
		9
	],
	"./skins/fynske-bank-sep-2024.css": [
		408,
		27
	],
	"./skins/fynske-bank-sep-2024.js": [
		136,
		9
	],
	"./skins/ibc-jan-2024": [
		137,
		16
	],
	"./skins/ibc-jan-2024.js": [
		137,
		16
	],
	"./skins/sdu-businessschooldays-2024": [
		138,
		8
	],
	"./skins/sdu-businessschooldays-2024.css": [
		409,
		26
	],
	"./skins/sdu-businessschooldays-2024.js": [
		138,
		8
	],
	"./skins/sdu-businessschooldays-2025": [
		139,
		7
	],
	"./skins/sdu-businessschooldays-2025.css": [
		410,
		25
	],
	"./skins/sdu-businessschooldays-2025.js": [
		139,
		7
	],
	"./skins/skoledyst-oct-2023": [
		140,
		6
	],
	"./skins/skoledyst-oct-2023.css": [
		411,
		24
	],
	"./skins/skoledyst-oct-2023.js": [
		140,
		6
	],
	"./skins/skolernes-aktiedyst-2024": [
		141,
		5
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		412,
		23
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		141,
		5
	],
	"./skins/sommerdysten-ad-2023": [
		142,
		4
	],
	"./skins/sommerdysten-ad-2023.css": [
		413,
		22
	],
	"./skins/sommerdysten-ad-2023.js": [
		142,
		4
	],
	"./skins/sommerdysten-ak-2023": [
		143,
		3
	],
	"./skins/sommerdysten-ak-2023.css": [
		414,
		21
	],
	"./skins/sommerdysten-ak-2023.js": [
		143,
		3
	],
	"./skins/sommerdysten-is-2023": [
		144,
		2
	],
	"./skins/sommerdysten-is-2023.css": [
		415,
		20
	],
	"./skins/sommerdysten-is-2023.js": [
		144,
		2
	],
	"./skins/sydbank-sep-2020": [
		145,
		1
	],
	"./skins/sydbank-sep-2020.css": [
		416,
		19
	],
	"./skins/sydbank-sep-2020.js": [
		145,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		146,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		417,
		18
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		146,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 311;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 311
// module chunks = 34